import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_workbox_65b539a0 from 'nuxt_plugin_workbox_65b539a0' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_nuxticons_9aa83378 from 'nuxt_plugin_nuxticons_9aa83378' // Source: ./nuxt-icons.js (mode: 'all')
import nuxt_plugin_dayjsplugin_573246d9 from 'nuxt_plugin_dayjsplugin_573246d9' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_7b1b667d from 'nuxt_plugin_vuesocialsharingplugin_7b1b667d' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_recaptcha_511241f3 from 'nuxt_plugin_recaptcha_511241f3' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_6dc048bc from 'nuxt_plugin_nuxtsvgsprite_6dc048bc' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_vuescrollto_29cf17f6 from 'nuxt_plugin_vuescrollto_29cf17f6' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_templatesplugin03a860a7_17ea0c2a from 'nuxt_plugin_templatesplugin03a860a7_17ea0c2a' // Source: ./templates.plugin.03a860a7.js (mode: 'all')
import nuxt_plugin_templatesplugin10b260a6_16214e14 from 'nuxt_plugin_templatesplugin10b260a6_16214e14' // Source: ./templates.plugin.10b260a6.js (mode: 'client')
import nuxt_plugin_templatespluginc51030ba_00c65df2 from 'nuxt_plugin_templatespluginc51030ba_00c65df2' // Source: ./templates.plugin.c51030ba.js (mode: 'client')
import nuxt_plugin_templatesplugin568e0f44_7d21c890 from 'nuxt_plugin_templatesplugin568e0f44_7d21c890' // Source: ./templates.plugin.568e0f44.js (mode: 'client')
import nuxt_plugin_templatesplugin014ec7c2_8b2e6c42 from 'nuxt_plugin_templatesplugin014ec7c2_8b2e6c42' // Source: ./templates.plugin.014ec7c2.js (mode: 'client')
import nuxt_plugin_templatesplugin31f5bf10_0cc83084 from 'nuxt_plugin_templatesplugin31f5bf10_0cc83084' // Source: ./templates.plugin.31f5bf10.js (mode: 'client')
import nuxt_plugin_templatesplugin2966e447_026d898a from 'nuxt_plugin_templatesplugin2966e447_026d898a' // Source: ./templates.plugin.2966e447.js (mode: 'client')
import nuxt_plugin_templatesplugin68ef8809_6a023a30 from 'nuxt_plugin_templatesplugin68ef8809_6a023a30' // Source: ./templates.plugin.68ef8809.js (mode: 'client')
import nuxt_plugin_templatesplugin76bc2d40_de780374 from 'nuxt_plugin_templatesplugin76bc2d40_de780374' // Source: ./templates.plugin.76bc2d40.js (mode: 'client')
import nuxt_plugin_templatesplugin7235808a_7ce06014 from 'nuxt_plugin_templatesplugin7235808a_7ce06014' // Source: ./templates.plugin.7235808a.js (mode: 'client')
import nuxt_plugin_templatesplugin4cfb1a2a_7224a9aa from 'nuxt_plugin_templatesplugin4cfb1a2a_7224a9aa' // Source: ./templates.plugin.4cfb1a2a.js (mode: 'client')
import nuxt_plugin_axios_8ed7d4f8 from 'nuxt_plugin_axios_8ed7d4f8' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_plugin_0007842a from 'nuxt_plugin_plugin_0007842a' // Source: ./nuxt-speedkit/plugin.js (mode: 'all')
import nuxt_plugin_smoothscrollpolyfill_46f37e6f from 'nuxt_plugin_smoothscrollpolyfill_46f37e6f' // Source: ./nuxt-polyfill/smoothscroll-polyfill.js (mode: 'all')
import nuxt_plugin_intersectionobserver_5ca555d4 from 'nuxt_plugin_intersectionobserver_5ca555d4' // Source: ./nuxt-polyfill/intersection-observer.js (mode: 'all')
import nuxt_plugin_urlpolyfill_3e85ec5e from 'nuxt_plugin_urlpolyfill_3e85ec5e' // Source: ./nuxt-polyfill/url-polyfill.js (mode: 'all')
import nuxt_plugin_prompteventpwa_a3d00858 from 'nuxt_plugin_prompteventpwa_a3d00858' // Source: ../plugins/prompt-event-pwa (mode: 'client')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_elementui_a6a1b20a from 'nuxt_plugin_elementui_a6a1b20a' // Source: ../plugins/element-ui (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_globalmixins_415d51c6 from 'nuxt_plugin_globalmixins_415d51c6' // Source: ../plugins/global-mixins (mode: 'all')
import nuxt_plugin_globalcomponents_91a8526c from 'nuxt_plugin_globalcomponents_91a8526c' // Source: ../plugins/global-components (mode: 'all')
import nuxt_plugin_globalfilters_775d0cc7 from 'nuxt_plugin_globalfilters_775d0cc7' // Source: ../plugins/global-filters (mode: 'all')
import nuxt_plugin_vueautosuggest_3c242af8 from 'nuxt_plugin_vueautosuggest_3c242af8' // Source: ../plugins/vue-autosuggest (mode: 'all')
import nuxt_plugin_vueawesomeswiper_4af85e3f from 'nuxt_plugin_vueawesomeswiper_4af85e3f' // Source: ../plugins/vue-awesome-swiper (mode: 'client')
import nuxt_plugin_lazyhydration_3be0a25a from 'nuxt_plugin_lazyhydration_3be0a25a' // Source: ../plugins/lazy-hydration (mode: 'all')
import nuxt_plugin_resizeobserver_2fa00d99 from 'nuxt_plugin_resizeobserver_2fa00d99' // Source: ../plugins/resize-observer (mode: 'client')
import nuxt_plugin_kiwi_5480bf58 from 'nuxt_plugin_kiwi_5480bf58' // Source: ../plugins/custom/kiwi (mode: 'client')
import nuxt_plugin_sherpa_44def7db from 'nuxt_plugin_sherpa_44def7db' // Source: ../plugins/custom/sherpa (mode: 'client')
import nuxt_plugin_checkbeforemove_64611f64 from 'nuxt_plugin_checkbeforemove_64611f64' // Source: ../plugins/check-before-move (mode: 'client')
import nuxt_plugin_tocca_33578c20 from 'nuxt_plugin_tocca_33578c20' // Source: ../plugins/tocca (mode: 'client')
import nuxt_plugin_zohowidget_bd7582e6 from 'nuxt_plugin_zohowidget_bd7582e6' // Source: ../plugins/custom/zoho-widget (mode: 'client')
import nuxt_plugin_zohosurvey_c9bce8ba from 'nuxt_plugin_zohosurvey_c9bce8ba' // Source: ../plugins/custom/zoho-survey (mode: 'client')
import nuxt_plugin_auth_2274d32c from 'nuxt_plugin_auth_2274d32c' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth_6a7e4e1e from 'nuxt_plugin_auth_6a7e4e1e' // Source: ../plugins/auth (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"fade-transform","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"LocalAdventures","htmlAttrs":{"lang":"es"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"name","content":"LocalAdventures"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"LocalAdventures"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"name":"google-site-verification","content":"PXjA2oe3srN4z6dcDd1XUcXHyEtGYg2NDYgs-54itu0"},{"name":"google-site-verification","content":"MEoqqh_LxiKN9ldmmJsXatOuvjs1ZA9f8Xx-QVs-Bww"},{"name":"p:domain_verify","content":"e2d76cf3c70fbd03b295cf297ab3bdc2"},{"hid":"fb:app_id","property":"fb:app_id","content":"315719405879512"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:site_name","property":"og:site_name","content":"LocalAdventures"},{"hid":"og:locale","property":"og:locale","content":"es_MX"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","name":"twitter:site","content":"@localoficial"},{"hid":"twitter:widgets:csp","name":"twitter:widgets:csp","content":"on"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"description","name":"description","content":"Reunimos las mejores aventuras a nivel mundial, operadas por expertos locales"},{"hid":"theme-color","name":"theme-color","content":"#5CB862"},{"hid":"og:title","name":"og:title","property":"og:title","content":"LocalAdventures"},{"hid":"og:description","name":"og:description","property":"og:description","content":"Reunimos las mejores aventuras a nivel mundial, operadas por expertos locales"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","vmid":"font-awesome-css","href":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Ffont-awesome\u002F5.14.0\u002Fcss\u002Fall.min.css"},{"rel":"preconnect","href":"\u002F\u002Fcdn.localadventures.io"},{"rel":"preconnect","href":"https:\u002F\u002Fapi.localadventures.io"},{"rel":"preconnect","href":"\u002F\u002Fuse.fontawesome.com"},{"rel":"preconnect","href":"\u002F\u002Fcdnjs.cloudflare.com"},{"rel":"prefetch","href":"\u002F\u002Fcrm.zohopublic.com"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.94f6fc95.json"},{"rel":"shortcut icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_64x64.716ce1.png"},{"rel":"apple-touch-icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_512x512.716ce1.png","sizes":"512x512"}],"script":[{"vmid":"wf_analytics-zoho","src":"https:\u002F\u002Fcrm.zohopublic.com\u002Fcrm\u002FWebFormAnalyticsServeServlet?rid=2e1f6cb29d8b2990cd95d731551ca4246eafcbbd06a7bebb1da6f7eb50c103eagidee0081934705cdaf1a0c534f18568573678e232441282802638f6c68f1dee4b8gid885e3c1045bd9bdcc91bdf30f82b5696gid14f4ec16431e0686150daa43f3210513","body":true,"defer":true},{"vmid":"google-one-tab","src":"https:\u002F\u002Faccounts.google.com\u002Fgsi\u002Fclient","async":true,"defer":true},{"vmid":"crazyegg-script-src","type":"text\u002Fjavascript","src":"\u002F\u002Fscript.crazyegg.com\u002Fpages\u002Fscripts\u002F0120\u002F4281.js","async":true},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=UA-65738414-4","async":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_workbox_65b539a0 === 'function') {
    await nuxt_plugin_workbox_65b539a0(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxticons_9aa83378 === 'function') {
    await nuxt_plugin_nuxticons_9aa83378(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_573246d9 === 'function') {
    await nuxt_plugin_dayjsplugin_573246d9(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_7b1b667d === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_7b1b667d(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_511241f3 === 'function') {
    await nuxt_plugin_recaptcha_511241f3(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_6dc048bc === 'function') {
    await nuxt_plugin_nuxtsvgsprite_6dc048bc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_29cf17f6 === 'function') {
    await nuxt_plugin_vuescrollto_29cf17f6(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugin03a860a7_17ea0c2a === 'function') {
    await nuxt_plugin_templatesplugin03a860a7_17ea0c2a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin10b260a6_16214e14 === 'function') {
    await nuxt_plugin_templatesplugin10b260a6_16214e14(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatespluginc51030ba_00c65df2 === 'function') {
    await nuxt_plugin_templatespluginc51030ba_00c65df2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin568e0f44_7d21c890 === 'function') {
    await nuxt_plugin_templatesplugin568e0f44_7d21c890(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin014ec7c2_8b2e6c42 === 'function') {
    await nuxt_plugin_templatesplugin014ec7c2_8b2e6c42(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin31f5bf10_0cc83084 === 'function') {
    await nuxt_plugin_templatesplugin31f5bf10_0cc83084(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin2966e447_026d898a === 'function') {
    await nuxt_plugin_templatesplugin2966e447_026d898a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin68ef8809_6a023a30 === 'function') {
    await nuxt_plugin_templatesplugin68ef8809_6a023a30(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin76bc2d40_de780374 === 'function') {
    await nuxt_plugin_templatesplugin76bc2d40_de780374(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin7235808a_7ce06014 === 'function') {
    await nuxt_plugin_templatesplugin7235808a_7ce06014(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin4cfb1a2a_7224a9aa === 'function') {
    await nuxt_plugin_templatesplugin4cfb1a2a_7224a9aa(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_8ed7d4f8 === 'function') {
    await nuxt_plugin_axios_8ed7d4f8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0007842a === 'function') {
    await nuxt_plugin_plugin_0007842a(app.context, inject)
  }

  if (typeof nuxt_plugin_smoothscrollpolyfill_46f37e6f === 'function') {
    await nuxt_plugin_smoothscrollpolyfill_46f37e6f(app.context, inject)
  }

  if (typeof nuxt_plugin_intersectionobserver_5ca555d4 === 'function') {
    await nuxt_plugin_intersectionobserver_5ca555d4(app.context, inject)
  }

  if (typeof nuxt_plugin_urlpolyfill_3e85ec5e === 'function') {
    await nuxt_plugin_urlpolyfill_3e85ec5e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_prompteventpwa_a3d00858 === 'function') {
    await nuxt_plugin_prompteventpwa_a3d00858(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_a6a1b20a === 'function') {
    await nuxt_plugin_elementui_a6a1b20a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_globalmixins_415d51c6 === 'function') {
    await nuxt_plugin_globalmixins_415d51c6(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_91a8526c === 'function') {
    await nuxt_plugin_globalcomponents_91a8526c(app.context, inject)
  }

  if (typeof nuxt_plugin_globalfilters_775d0cc7 === 'function') {
    await nuxt_plugin_globalfilters_775d0cc7(app.context, inject)
  }

  if (typeof nuxt_plugin_vueautosuggest_3c242af8 === 'function') {
    await nuxt_plugin_vueautosuggest_3c242af8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiper_4af85e3f === 'function') {
    await nuxt_plugin_vueawesomeswiper_4af85e3f(app.context, inject)
  }

  if (typeof nuxt_plugin_lazyhydration_3be0a25a === 'function') {
    await nuxt_plugin_lazyhydration_3be0a25a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_resizeobserver_2fa00d99 === 'function') {
    await nuxt_plugin_resizeobserver_2fa00d99(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_kiwi_5480bf58 === 'function') {
    await nuxt_plugin_kiwi_5480bf58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sherpa_44def7db === 'function') {
    await nuxt_plugin_sherpa_44def7db(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_checkbeforemove_64611f64 === 'function') {
    await nuxt_plugin_checkbeforemove_64611f64(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tocca_33578c20 === 'function') {
    await nuxt_plugin_tocca_33578c20(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_zohowidget_bd7582e6 === 'function') {
    await nuxt_plugin_zohowidget_bd7582e6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_zohosurvey_c9bce8ba === 'function') {
    await nuxt_plugin_zohosurvey_c9bce8ba(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_2274d32c === 'function') {
    await nuxt_plugin_auth_2274d32c(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_6a7e4e1e === 'function') {
    await nuxt_plugin_auth_6a7e4e1e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
